import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'

import { developerRootRoute } from '@/tenant/developer/root'

import { SearchSchema, listApiLogs } from './routeUtils'

const validateSearch = createValidateSearch(SearchSchema)

export const apiLogRoute = createRoute({
    getParentRoute: () => developerRootRoute,
    path: '/apiLogs',
    component: lazyRouteComponent(() => import('./ApiLogs'), 'ApiLogs'),
    validateSearch,
    loaderDeps: ({ search }) => search,
    loader: ({ deps, abortController }) => listApiLogs(deps, 0, abortController),
})
